<template lang="html">
    <div class="fadeImagewrapper">
        <transition name="fade">
            {{ srcImage }}
            <span class="imageOverlay">
                <img :src="require('@/' + srcImage + '')" @load="onLoaded" v-show="loaded" />&nbsp;
            </span>
        </transition>
    </div>
</template>

<script>
export default {
    name: "fade-image",
    props: {
        src: {
            required: true,
        },
    },
    computed: {
        srcImage() {
            if (this.$store.state.user.gender == "Female") {
                return this.src.replace("headers/", "headers/Female/");
            } else {
                return this.src.replace("headers/", "headers/Male/");
            }
        },
    },
    data: function () {
        return {
            loaded: false,
        };
    },
    methods: {
        onLoaded() {
            this.loaded = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.fadeImagewrapper {
    width: 100%;
    .imageOverlay {
        position: relative;
        display: block;
        &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 104%;
            background: rgba(38, 121, 98, 0.3);
            background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 1) 6%,
                rgba(38, 121, 98, 0.30155812324929976) 15%
            );
            top: 0px;
            left: 0px;
        }
    }
    &.darken {
        &:after {
            content: "";
            width: 100%;
            height: 100%;
            background: rgba(38, 121, 98, 0.7);
            display: block;
            position: absolute;
            top: 0px;
        }
    }
}

.fade-enter-active {
    //transition: all 1s ease-in-out;
}

.fade-enter-to {
    opacity: 1;
}

.fade-enter {
    opacity: 0;
}
</style>
